<template>
  <div class="side userinfo-fn-mod">
    <div class="box">
      <a
        href="javascript:;"
        class="start-wp"
        @click="
          goServer('JRYX', '进入游戏')
          reportClick('play')
        "
      >
        <span></span>
      </a>
      <p class="userinfo-fn-dl">
        <a
          href="javascript:;"
          @click="
            $router.push(`/game-offical/${$route.params.game_id}/gift`)
            reportClick('gift')
          "
          >游戏礼包</a
        >
        <a
          v-if="game.jump_url"
          :href="game.jump_url"
          target="_blank"
          @click="reportClick('client_dl')"
          >微端下载</a
        >
      </p>
      <template v-if="showUser">
        <template v-if="$store.getters.isLogin">
          <div class="userinfo-fn-tips">
            <span> Hi，</span>
            <em @click="reportClick('nickname')">{{ userInfo.nickname }}，</em>
            <span> 你最近玩过的服 </span>
          </div>
          <p class="userinfo-fn-area">
            <a
              v-for="(item, index) in serverList.slice(0, 6)"
              :key="item.server_id"
              href="javascript:;"
              class="ellipsis-1"
              @click="
                goServer(`ZJYX${index + 1}`, `最近游戏${index + 1}`, item)
                reportClick(`channel_${item.server_id}`)
              "
            >
              {{ item.title }}&gt;
            </a>
          </p>
        </template>
        <div v-else class="userinfo-fn-tips">
          <a
            href="javascript:;"
            style="color: #fff"
            @click="$store.commit('app/setLoginPop', true)"
            >当前未登录账号</a
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showUser: {
      type: Boolean,
      default: true
    },
    xla: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    game() {
      return this.$store.state.game.info
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    recentlyPlayed() {
      return this.$store.state.user.recentlyPlayed || []
    },
    serverList() {
      return (this.recentlyPlayed[0] || {}).latest_server_list || []
    }
  },
  created() {
    if (process.client) {
      this.$store
        .dispatch('user/getRecentlyPlayed', {
          game_id: this.$route.params.game_id
        })
        .then(() => {
          this.$xlaGamePush(this.xla.show, {
            game_id: this.$route.params.game_id,
            channel_list:
              this.recentlyPlayed.map((e) => e.server_id).join('_') || 'none'
          })
        })
    }
  },
  methods: {
    reportClick(click_id) {
      this.$xlaGamePush(this.xla.click, {
        game_id: this.$route.params.game_id,
        click_id
      })
    },
    goServer(eid, eid_desc, { server_id } = {}) {
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      if (!server_id) {
        const { latest_server_list = [], server_list = [] } =
          this.recentlyPlayed[0] || {}
        server_id =
          (latest_server_list[0] || server_list[0] || {}).server_id || 0
      }
      this.$util.gameStat(
        this.$route.params.game_id,
        server_id,
        `${this.$route.params.game_id}/GW/SY/${eid}`,
        `${this.$route.params.game_id}/官网/首页/${eid_desc}`
      )
    }
  }
}
</script>
